var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('a',{attrs:{"href":_vm.itemLink}},[_vm._v(_vm._s(_vm.gameTitle))]),_vm._v(" "),_c('span',{class:_vm.classes},[_vm._v(_vm._s(_vm.consoleName))])]),_vm._v(" "),(_vm.comment)?_c('small',[_vm._v(_vm._s(_vm.comment))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c5f2eee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UnplayedListItem.vue
// module id = null
// module chunks = 